import { css } from 'emotion';
import { space } from '@joykit';
import { animationTransition } from '@joykit/variables';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import chroma from 'chroma-js';
import { aspectContainer } from '@joykit/helpers/aspectContainer';

export namespace styles {
  export const container = css({});

  export const exhibitContainer = css({
    width: '400px',
    height: 325,
    maxWidth: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'center',
    '@media(min-width: 375px)': {
      height: 350
    },
    '@media(min-width: 400px)': {
      height: 375
    },
    '@media(min-width: 450px)': {
      height: 400
    }
  });

  export const exhibitPhotoContainer = css({
    position: 'relative',
    marginBottom: 16,
    '@media(min-width: 450px)': {
      marginBottom: 0
    },
    ':hover': {
      ' .exhibit-overlay': {
        opacity: 1,
        visibility: 'visible'
      }
    }
  });

  export const mobileCreateButton = css({
    borderBottom: '1px solid #333',
    ...getInterUIDynamicMetricCssObject(15),
    textTransform: 'capitalize',
    color: '#333',
    margin: '0.5rem 0',
    cursor: 'pointer',
    transition: animationTransition('color'),
    ':hover': {
      color: chroma('#333')
        .darken()
        .css()
    }
  });

  export const exhibitPhoto = (aspectRatio: number) =>
    css({
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundPosition: 'center top',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      margin: '0 auto',
      maxWidth: '100%',
      borderRadius: '0 0 4px 4px',
      boxShadow: 'rgba(0, 0, 0, 0.2) 0px 8px 24px -8px',
      width: 360,
      ...aspectContainer(aspectRatio)
    });

  export const exhibitOverlay = css({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, .83)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0,
    transition: animationTransition('opacity')
  });

  export const darkButton = css({
    margin: space.stack.md,
    backgroundColor: '#333333',
    color: 'white',
    padding: '16px 64px',
    transition: animationTransition('background-color'),
    ':hover': {
      backgroundColor: chroma('#333')
        .darken()
        .css()
    }
  });
  export const underlineButton = css({
    borderBottom: '1px solid #333',
    transition: animationTransition('color'),
    ':hover': {
      color: chroma('#333')
        .darken()
        .css()
    }
  });

  export const exhibitInfoContainer = css({
    textAlign: 'center',
    position: 'absolute',
    bottom: '8px',
    left: '50%',
    transform: 'translateX(-50%)'
  });

  export const exhibitInfoLayout = css({
    ...getInterUIDynamicMetricCssObject(13),
    textTransform: 'capitalize',
    color: '#888888'
  });

  export const exhibitInfoStyle = css({
    ...getInterUIDynamicMetricCssObject(15),
    textTransform: 'capitalize',
    color: '#333',
    margin: space.stack.sm
  });

  export const monitorShell = css({
    position: 'absolute',
    top: '-10px',
    left: '0px',
    width: '100%',
    height: '10px',
    backgroundColor: '#e8e8e8',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    display: 'flex',
    alignItems: 'center'
  });

  export const monitorCircle = css({
    height: 3,
    width: 3,
    borderRadius: '50%',
    marginLeft: 4,
    ':nth-child(1)': {
      backgroundColor: '#FF6159',
      marginLeft: 8
    },
    ':nth-child(2)': {
      backgroundColor: '#FFBF2F'
    },
    ':nth-child(3)': {
      backgroundColor: '#29CD42'
    }
  });

  export const column = css({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '0 !important',
    paddingTop: '1rem !important',
    '@media(min-width: 450px)': {
      padding: '1rem !important'
    }
  });

  export const mobileInfoContainer = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '1rem'
  });
}
